<script setup lang="ts">
import axios from 'axios';
import FilemanagerUploadHost from './components/filemanager/UploadHost.vue';

const viewportQuery = import.meta.client ? window.matchMedia('(width < 360px)') : null;
const viewportTooSmall = ref(viewportQuery?.matches ?? false);

function updateViewport()
{
    viewportTooSmall.value = viewportQuery?.matches ?? false;
}

onMounted(() => viewportQuery?.addEventListener('change', updateViewport));
onBeforeUnmount(() => viewportQuery?.removeEventListener('change', updateViewport));

const appHash = ref<string>('');
const frequency = ref<number>(2 * 60 * 1000);

const { $alert } = useAlerts();
const { $log } = useLogging();
const { $t } = useLocalization();

onBeforeMount(async () =>
{
    if (import.meta.env.PROD)
    {
        await checkVersion(`${location.origin}/_nuxt/builds/latest.json`);
    }

    await useThemeStore().initColors();
});

async function checkVersion(url: string)
{
    appHash.value = await loadManifest(url);

    setInterval(async () =>
    {
        const result = await loadManifest(url);

        if (result)
        {
            appHash.value = result;
        }
    },
    frequency.value);
}

async function loadManifest(url: string)
{
    try
    {
        const time = new Date();

        time.setSeconds(0);
        time.setMilliseconds(0);

        const response = await axios.get(`${url}?t=${time.getTime()}`);

        return response.data.id;
    }
    catch (ex)
    {
        handleException($log, ex, {
            0: (ex: any) => $alert.danger(ex.message)
        });

        return null;
    }
}

watch(appHash, (value, old) =>
{
    if (value !== old && old)
    {
        const message = $t('[[[Dostępna jest nowa aktualizacja]]]');
        const description = $t('[[[Proszę zapisać postęp pracy i kliknąć przycisk „Aktualizuj”. Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.]]]');

        $alert.info(message, {
            description,
            dismissible: false,
            important: true,
            duration: 0,
            action: {
                label: $t('[[[Aktualizuj]]]'),
                onClick: () => location.reload()
            }
        });
    }
});
</script>

<template>
    <EditoMinimumViewport v-if="viewportTooSmall" />
    <div v-else-if="!$auth.ready()" class="flex h-full items-center justify-center">
        <Loader />
    </div>
    <NuxtLayout v-else>
        <NuxtPage />
    </NuxtLayout>
    <FilemanagerUploadHost v-if="$auth.ready()" />
    <IdeoToaster v-if="!viewportTooSmall" />
</template>
